import { ModalHandler } from "@lib/ModalHandler";
import { randNum } from "@lib/util/common";
import { Accessor } from "solid-js";
import {
  clickSaveButton,
  getQuestionHandler,
  waitForRegularSectionPage,
  waitForSOMainMenu,
} from "../form_handlers";
import { clickSurveySection } from "../form_util";

export async function completeKcPresets(_totalInStock: number, modalHandler: Accessor<ModalHandler>) {
  await fillShelfAfter(modalHandler);
}

async function fillShelfAfter(modalHandler: Accessor<ModalHandler>) {
  const [clicked] = await clickSurveySection(/shelf after/i, modalHandler, waitForRegularSectionPage, true);
  if (!clicked) {
    return;
  }

  /******************** Begin Questions ********************/
  getQuestionHandler("textinput", 1, /unit.*added.*outside of the distribution check/i)?.answer(
    randNum(10, 15).toString()
  );
  getQuestionHandler("textinput", 2, /tag.*added.*outside of the distribution check/i)?.answer(
    randNum(0, 1).toString()
  );
  getQuestionHandler("textinput", 3, /total orders placed outside of the distribution check/i)?.answer(
    randNum(0, 1).toString()
  );

  /******************** End Questions ********************/

  clickSaveButton();
  await waitForSOMainMenu(modalHandler);
}
